import { environment } from "../../environment";
import { createFormData } from "../helpers/helpers";
import axios from "axios";


export const CurriculaService = () => {
    const syncCurricula = async (curriculumId: string) => {
        try {
            const url = `${environment.authUrl}sync/curricula/${curriculumId}`;
            return await axios.get(url);
        } catch (error) {
            console.error("Error syncing curriculum:", error);
            throw error;
        }
    };

    const getCurriculaList = async (entityStatus: string) => {
        try {
            const path = environment.authUrl + "sync/curriculaList/" + entityStatus;
            return await axios.get(path);
        } catch (err) {
            throw err;
        }
    };

    const filterCurriculaList = async (entityParam: string) => {
        try {
            const path = environment.authUrl + "filter/filterCurriculaList/" + entityParam;
            return await axios.get(path);
        } catch (err) {
            throw err;
        }
    };

    const updateCurriculum = async (data: any) => {
        try {
            const formData: FormData = new FormData();
            formData.append('data', JSON.stringify(data));
            formData.append('thumbnail', data.thumbnail);
            return await axios.post(environment.contentUrl + "enhancedContent/updateCurriculum", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            });
        } catch (err) {
            throw err;
        }
    };

    const removeUserFromCurriculum = async (formData: any) => {
        try {
            return await axios.put(environment.contentUrl + "enhancedContent/removeUserFromCurriculum", formData, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
        } catch (err) {
            throw err;
        }
    };

    return {
        syncCurricula,
        getCurriculaList,
        filterCurriculaList,
        updateCurriculum,
        removeUserFromCurriculum
    }
}